module.exports = __webpack_public_path__ + "static/img/max_pictgrid33_1080x832.fd1ae15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/max_pictgrid33_1080x832.jpg
// module id = NJ3f
// module chunks = 0